const NotFound = ({title}) => {
    return ( 
        <div className="not-found">
            <img src="/assets/error-404.png" alt="not-found" />
            <p>{title}</p>
        </div>
     );
}
 
export default NotFound;